// extracted by mini-css-extract-plugin
export default {"chartTab":"chart_chartTab__61Kk5","title":"chart_title__nu7xd","selected":"chart_selected__sEPPH","opacity-transition":"chart_opacity-transition__dP5iq"};